import { Button } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useExpiredToken from "../utils/useExpiredToken";

const Unauthorized = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  if (!token) {
    expireToken();
  }

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light text-center">
      <div>
        <h1 className="display-4 fw-bold text-danger">401 - Unauthorized</h1>
        <p className="lead">You don’t have permission to access this page.</p>
        <Button className="mt-3" type="primary" onClick={() => navigate("/")}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
